export class Network {
  static get TIMEOUT() { return 5000; }
}
